import { render } from "./ServiceReportSupervisorUpdate.vue?vue&type=template&id=65980291"
import script from "./ServiceReportSupervisorUpdate.vue?vue&type=script&lang=js"
export * from "./ServiceReportSupervisorUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__